<template><component :is="periodComponentName" /></template>

<script>
/**
 * @module TeacherCoursePeriodEntry
 * @desc Teacher CoursePeriod 按课程类型分发。
 */
export default {
  name: 'TeacherCoursePeriodEntry',
  components: {
    SeminarPeriod: () => import('./Seminar'),
    CapstonePeriod: () => import('./Capstone')
  },
  computed: {
    periodComponentName() {
      return this.$route.params.period === 'CP' ? 'CapstonePeriod' : 'SeminarPeriod';
    }
  }
};
</script>
